import { Component, Input } from '@angular/core';

import { QuantitySelectorComponent } from '../../../../product/quantity-selector/quantity-selector.component';
import { ShippingSelectorComponent } from '../../../../product/shipping-selector/shipping-selector.component';

import { DeliveryItemsTablePriceBlockComponent } from '../../../delivery-items-table-price-block/delivery-items-table-price-block.component';
import { CommonModule } from '@angular/common';

import { OrderStatusBlockComponent } from '../../../../order-status-block/order-status-block.component';
import { AdjustItemQuantityMutation, AdjustItemQuantityMutationVariables, Order, OrderLine, RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables } from '../../../../../../graphql/generated/generated-types';
import { DataService } from '../../../../../../core/providers/data/data.service';
import { ADJUST_ITEM_QUANTITY, REMOVE_ITEM_FROM_CART } from '../../../../product/price-and-actions-block/product-cart.graphql';
import { Observable, debounceTime, of, take } from 'rxjs';
import { MessageService } from 'primeng/api';
import { FormatPricePipe } from '../../../../../pipes/format-price.pipe';
import { ToastSeverity } from '../../../../../notification/notification.component';


@Component({
  selector: 'app-delivery-item-actions-block',
  standalone: true,
  imports: [CommonModule, ShippingSelectorComponent, QuantitySelectorComponent, DeliveryItemsTablePriceBlockComponent, 
    OrderStatusBlockComponent, FormatPricePipe],
  templateUrl: './delivery-item-actions-block.component.html',
  styleUrl: './delivery-item-actions-block.component.scss'
})
export class DeliveryItemActionsBlockComponent {
  @Input() orderLine: OrderLine;
  @Input() order: Order;
  @Input() product: any;
  @Input() inOrder: boolean = false;
  @Input() inCart!: boolean;
  public loading$: Observable<boolean>;
  constructor(private dataService: DataService, private messageService: MessageService){

  }
  
  setQuantity(event: { itemId: string; quantity: number; }) {
    if (0 < event.quantity) {
        this.adjustItemQuantity(event.itemId, event.quantity);
    } else {
        this.removeItem(event.itemId);
    }
}

private adjustItemQuantity(id: string, qty: number) {
  this.loading$ = of(true);
  this.dataService.mutate<AdjustItemQuantityMutation, AdjustItemQuantityMutationVariables>(ADJUST_ITEM_QUANTITY, {
      id,
      qty,
  }).pipe(
    take(1),
  ).subscribe(({ adjustOrderLine }) => {
      switch (adjustOrderLine.__typename) {
          case 'Order':
              break;
          case 'InsufficientStockError':
          case 'NegativeQuantityError':
          case 'OrderLimitError':
          case 'OrderModificationError':
            this.messageService.add({ severity: ToastSeverity.Error, key: 'notifications', summary: 'Error', detail: `${adjustOrderLine.message}` });
              break;
      }
      this.loading$ = of(false);
  });
}

private removeItem(id: string) {
  this.loading$ = of(true);
  this.dataService.mutate<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>(REMOVE_ITEM_FROM_CART, {
      id,
  }).pipe(
      take(1),
  ).subscribe({
    complete : () => {
      this.loading$ = of(false);
    }
   });
}

}
